const architects = [
  {
    id: 'A1',
    url: 'zaborsky',
    name: 'Заборский Георгий Владимирович',
    bornDate: '11/11/1909',
    born: '11 ноября 1909',
    deceased: '27 апреля 1999',
    description: 'Народный архитектор СССР (1981), заслуженный строитель Беларуси, академик Российской академии архитектуры и строительных наук, академик Белорусской академии архитектуры, лауреат Государственной премии СССР (1971).',
    image: 'http://bsa.by/ckfinder/userfiles/images/4(2).jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Минск',
    bio: [
      {date: '1909', text: 'Георгий Заборский родился в Минске в семье Владимира Георгиевича Заборского, бухгалтера Московско-Брестской железной дороги, и Елены Ивановны Заборской (Зеглинг).'},
      {date: '1930', text: 'Поступил в Минскую профтехшколу крестьянского огнеупорного строительства. Первую практику Г. Заборский проходил на строительной площадке здания Дома правительства. Здесь же произошло его знакомство с архитектором И. Лангбардом.'},
      {date: '1939', text: 'Окончил Академию искусств. По конкурсу попал в Москву, но работал там недолго и быстро получил направление в Минск. Здесь он был назначен руководителем научной экспедиции по изучению памятников архитектуры и искусства Гомельской и Полесской областей.'},
      {date: '1941-1945', text: 'Пошел на фронт добровольцем, но в боях под Смоленском был тяжело ранен и оказался в госпитале уральского городка Троицка, где выполнил ряд проектов-эскизов памятников, посвященных героической победе советского народа в Великой Отечественной войне.'},
      {date: '1945-1964', text: 'Георгий Заборский руководит архитектурно-конструкторскими мастерскими проектных институтов Белгоспроект и Минскпроект и одновременно преподает на архитектурном отделении Белорусского политехнического института (ныне УО «Белорусский национальный технический университет»).'},
      {date: '1993', text: 'Закончил творческую деятельность. Одной из последних его работ стал проект памятника жертвам массовых репрессий в Куропатах под Минском.'},
    ],
    project: [
      {date: '1952', text: 'Спроектировал дом для семьи Я. Коласа.'},
      {date: '1954', text: 'Памятник-монумент на пл. Победы.'},
      {date: '1962', text: 'По проектам архитектора построены кинотеатр «Пионер» и музей Великой Отечественной войны.'},
      {date: '1969', text: 'Открытие мемориального комплекса «Зислов».'},
    ],
    video: {
      id: 'lxMfVdAml1A'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://naviny.by/media/2015.09_w1/yacub.jpg',
        width: 4,
        height: 3,
        title: 'Памятник Я.Колосу',
        text: 'Памятник писателю Якубу Колосу.'
      },
      {
        num: 2,
        src: 'https://minsknews.by/wp-content/uploads/2018/05/APD_8846-1.jpg',
        width: 2,
        height: 2,
        title: 'Памятник-монумент на пл. Победы',
        text: 'Памятник-монумент на пл. Победы.'
      },
      {
        num: 3,
        src: 'https://minsk-old-new.com/assets/images/Image/streets/krasnoarmeyskaya/krasnoarmeyskaya-024.jpg',
        width: 2,
        height: 2,
        title: 'Здание ЦК ЛКСМБ',
        text: 'Здание ЦК ЛКСМБ.'
      },
      {
        num: 4,
        src: 'https://planetabelarus.by/upload/resize_cache/iblock/901/1330_887_18e21fe612b4afb807a26ecc22279a1d9/901c0376763ffee6a3fb245ea62fba25.jpg',
        width: 4,
        height: 3,
        title: 'Минское Суворовское военное училище',
        text: 'Минское Суворовское военное училище.'
      },
    ],
  },

  {
    id: 'A2',
    url: 'usova',
    name: 'Усова Любовь Дмитриевна',
    bornDate: '9/6/1921',
    born: '6 сентября 1921',
    deceased: 'настоящее время',
    description: 'Любовь Дмитриевна Усова – личность в архитектурных кругах известная. Прежде всего она вошла в строительную летопись Беларуси как один из разработчиков нового послевоенного генплана города Минска. При ее непосредственном участии в столице возведены многие знаковые объекты. За свою творческую деятельность неоднократно награждалась грамотами Верховного Совета БССР, почетными грамотами и грамотами института \'Минскпроект\', а также  Союзов архитекторов СССР и БССР. Занесена в книгу почета института \'Минскпроект\'.',
    image: 'https://minsknews.by/wp-content/uploads/2014/10/Arhitektor-Usova-3.jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Иркутск',
    bio: [
      {date: '1921', text: 'Родилась в Иркутске в семье служащих.'},
      {date: '1930', text: 'Cемья переехала в Москву, где Любовь после окончания школы поступила в Московский архитектурный институт.'},
      {date: '1941-1945', text: 'Во время Великой отечественной войны находилась в эвакуации в Ташкенте.'},
      {date: '1947', text: 'Защитила с отличием дипломный проект, после чего по распределению направлена на работу в Минск в архитектурно-планировочную мастерскую при Мингоркомкоме, где работал ее муж Василий Иосифович Геращенко.'},
      {date: '1989', text: 'Занесена в книгу почета института «Минскпроект».'},
    ],
    project: [
      {date: '1950', text: 'Проектировала и восстанавливала главный корпус БПИ (БНТУ).'},
      {date: '1952', text: 'Спроектировала Дворец пионеров и школьников.'},
      {date: '1954', text: 'Спроектировала здание обкома КПБ.'},
      {date: '1956', text: 'Спроектировала Белорусский республиканский театр юного зрителя.'},
      {date: '1960-1970', text: 'Выполнила ряд работ по привязке и реконструкции школ, детских садов, проектировала жилые дома совместно с мужем в районе Привокзальной площади, для рабочих Мотовелозавода, жилые кварталы заводов. Принимала участие в создании сквера возле театра оперы и балета парка Победы, занималась реконструкцией детского парка имени М. Горького.'},
      {date: '1968', text: 'Спроектировала республиканский дом юного техника.'},
      {date: '1970-1980', text: 'Выполняла архитектурно-планировочную часть Минского водного каскада — водохранилищ Дрозды и Криница.'},
    ],
    video: {
      id: 'FCQd9J67N0o'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0002.jpg',
        width: 4,
        height: 3,
        title: 'Любовь Усова с коллегами',
        text: 'Любовь Усова (справа) с коллегами за работой над проектом кинотеатра \'Зорька\'.'
      },
      {
        num: 2,
        src: 'http://arcp.by/sites/arcp.by/files/styles/660/public/articlefoto/rsg-13-2014_final_stranica_5_izobrazhenie_0004.jpg',
        width: 2,
        height: 2 ,
        title: 'Вместе с мужем',
        text: 'Любовь Усова вместе с мужем Василием Геращенко.'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Minsk_CIS_executive_committee.JPG/800px-Minsk_CIS_executive_committee.JPG',
        width: 2,
        height: 2,
        title: 'Здание обкома КПБ',
        text: 'Здание обкома КПБ.'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Belarus-Minsk-Railway_Station_Square-4.jpg/800px-Belarus-Minsk-Railway_Station_Square-4.jpg',
        width: 2,
        height: 2,
        title: 'Привокзальная площадь г.Минска',
        text: 'Ворота Минска на Привокзальной площади.'
      },
      {
        num: 5,
        src: 'https://farm4.static.flickr.com/3286/2958042964_43082c0ef6_o.jpg',
        width: 4,
        height: 3,
        title: 'Республиканский Дворец пионеров и школьников',
        text: 'Республиканский Дворец пионеров и школьников.'
      },
      {
        num: 6,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Enhie%C4%BAsa_Street_26.jpg/1024px-Enhie%C4%BAsa_Street_26.jpg',
        width: 2,
        height: 2,
        title: 'Театр юного зрителя',
        text: 'Белорусский государственный академический театр юного зрителя.'
      },
      {
        num: 7,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/BNTU.JPG',
        width: 4,
        height: 3,
        title: 'Главный корпус БНТУ',
        text: 'Главный корпус Белорусского национального технического университета.'
      },
      {
        num: 8,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG/1024px-Alleya_of_Opera_and_Ballet_Theatre%2C_Minsk.JPG',
        width: 2,
        height: 2,
        title: 'Троицкая гора',
        text: 'Сквер вокруг Национального акадэмического Большого театра оперы и балета Республики Беларусь.'
      },
      {
        num: 9,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg/1280px-%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BD%D0%B8%D0%BA_%D0%97%D0%B0%D1%85%D0%B0%D1%80%D0%B8%D1%8E_%D0%9A%D0%BE%D1%80%D0%BD%D0%B5%D0%B5%D0%B2%D1%83%2C_Minsk%2C_Belarus_-_panoramio_%281%29.jpg',
        width: 2,
        height: 2,
        title: 'Парк им. М.Горького',
        text: 'Центральный детский парк имени Максима Горького. Пешеходный мост через набережную р. Свислочь'
      },
    ],
  },

  {
    id: 'A3',
    url: 'parusnikov',
    name: 'Парусников Михаил Павлович',
    bornDate: '11/12/1893',
    born: '12 ноября 1893',
    deceased: '2 февраля 1968',
    description: 'Советский архитектор, действительный член Академии Архитектуры СССР (1950), академик АН БССР (1950; член-корреспондент с 1947). Педагог, профессор (с 1948). Лауреат Государственной премии Белорусской ССР (1968).',
    image: 'http://cn.flibusta.site/i/89/452389/img_84.jpg',
    placeOfResidence: 'Москва',
    placeOfBirth: 'Москва',
    bio: [
      {date: '1913 - 1918', text: 'Обучался в МУЖВЗ (его отец был настоятелем соседнего храма), затем до 1924 года во ВХУТЕМАСе.'},
      {date: '1924', text: 'Работал в архитектурно-проектных организациях Москвы и одновременно преподавал (1934—1941 годах, с 1948 года — профессор) в МАРХИ.'},
      {date: '1941 - 1944', text: 'Старший научный сотрудник Академии архитектуры СССР.'},
      {date: '1944 - 1948', text: 'Руководитель архитектурно-проектных мастерских Комитета по делам архитектуры СССР.'},
    ],
    project: [
      {date: '1930', text: 'Автор проекта планировки и застройки Астрахани'},
      {date: '1923', text: 'Павильон машиностроения и аудитория на Всероссийской сельскохозяйственной и кустарно-промышленной выставке в Москве'},
      {date: '1936', text: 'Ряд жилых домов на проспекте Мира в Москве «Дома с аркой» в Ярославле, в том числе дом на Красной площади'},
      {date: '1945—1947', text: 'Административное здание — КГБ Беларуси'},
      {date: '1950', text: 'Госбанк БССР'},
      {date: '1946—1954', text: 'Жилые дома и мост через р. Свислочь, Спортивный комплекс «Динамо».'},
    ],
    video: {
      id: 'mrfadR51D0I'
    },
    mapData: {
      center: [53.898869, 27.554819],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Minsk_skaryny_ave_02.jpg',
        width: 4,
        height: 3,
        title: 'Здание КГБ в Минске',
        text: 'Здание КГБ в Минске'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/3/32/NBRB.JPG',
        width: 2,
        height: 2,
        title: 'Здание Нацбанка РБ',
        text: 'Здание Нацбанка РБ'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/c/c5/Захар%27еўскі_мост.jpg',
        width: 2,
        height: 2,
        title: 'Мост через Свислочь',
        text: 'Мост через Свислочь'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Buildings_in_Yaroslavl_009.jpg',
        width: 4,
        height: 3,
        title: 'Дом с аркой на Красной площади',
        text: 'Дом с аркой на Красной площади'
      },
    ],
  },

  {
    id: 'A4',
    url: 'leonid-mendelevich',
    name: 'Леонид Менделевич Левин',
    bornDate: '07/25/1936',
    born: '25 июля 1936',
    deceased: '1 марта 2014',
    description: 'Заслуженный архитектор Республики Беларусь, Лауреат Ленинской премии и премии Ленинского комсомола, Лауреат премии Волгоградского Комсомола, дважды лауреат Государственной премии Республики Беларусь, лауреат многих престижных конкурсов и смотров архитектурных работ, Академик Международной и Белорусской Академий архитектуры, Председатель Союза белорусских еврейских общественных объединений и общин с 1991 года.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Levin_Leonid_Mendele.jpg/800px-Levin_Leonid_Mendele.jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Минск',
    bio: [
      {date: '1954 - 1960', text: 'Учёба в Белорусском политехническом институте.'},
      {date: '1960', text: 'Работа в Институте «Минскпроект» (от архитектора до руководителя Мастерской по застройке центра Минска)'},
      {date: '1960 - 1967', text: 'Участие в создании парка им. 50-летия Советской власти.'},
      {date: '1968', text: 'Участие в создании выставочного павильона ВДНХ БССР в Минске.'},
      {date: '1970', text: 'В составе авторского коллектива был удостоен Ленинской премии за мемориальный комплекс 1968—1969 гг. «Хатынь»'},
      {date: '1997', text: 'Директор собственной творческой мастерской УП «Творческая мастерская архитектора Л. Левина»'},
      {date: '4 марта 2014', text: 'Похоронен 4 марта 2014 года на Центральной аллее Восточного кладбища в Минске'},
    ],

    project: [
      {date: '1969', text: 'Мемориальный комплекс «Хатынь»'},
      {date: '1972', text: 'Памятник Янке Купале'},
      {date: '1972', text: 'Памятник Якубу Коласу'},
      {date: '1979', text: 'Шуневка (мемориальный комплекс «Проклятие фашизму»)'},
      {date: '1980 - 1986', text: 'Реконструкция исторической части Минска - «Троицкое предместье»'},
      {date: '1984', text: 'Авторство станции Минского метрополитена «Площадь Ленина»'},
      {date: '1990', text: 'Авторство станции Минского метрополитена «Немига»'},
      {date: '2004', text: 'Мемориальный комплекс погибшим евреям г. п. Городея'},
    ],
    video: {
      id: 'P2-yBJvcJUo'
    },
    mapData: {
      center: [53.906840, 27.571457],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/0/01/Khatyn_Memorial%2C_Belarus.jpg',
        width: 4,
        height: 3,
        title: 'Мемориальный комплекс Хатынь',
        text: 'Мемориальный комплекс Хатынь'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Belarus-Minsk-Memorial_Pit-2.jpg',
        width: 2,
        height: 2,
        title: 'Мемориал жертвам гитлеровского геноцида «Яма»',
        text: 'Мемориал жертвам гитлеровского геноцида «Яма»'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/ru/f/ff/Yanka-kupala-minsk.jpg',
        width: 3,
        height: 3,
        title: 'Памятник Янке Купале',
        text: 'Памятник Янке Купале'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/The_Minsk_Thinker_-_panoramio.jpg',
        width: 3,
        height: 4,
        title: 'Памятник Якубу Коласу',
        text: 'Памятник Якубу Коласу'
      },
    ],
  },

  {
    id: 'A5',
    url: 'yesman',
    name: 'Есьман Игорь Иванович',
    bornDate: '01/05/1932',
    born: '1 мая 1932',
    deceased: 'настоящее время',
    description: 'Архитектор, дизайнер и изобретатель Игорь Иванович Есьман мечтал построить на въезде в Минск грандиозный научно-учебный центр: Минский архитектурно-строительный институт (МАСИ) и сверхсовременный Белгосуниверситет.',
    image: 'https://s16.stc.all.kpcdn.net/share/i/12/2109386/inx960x640.jpg',
    placeOfResidence: 'Минск',
    placeOfBirth: 'Минск',
    bio: [
      {date: '1948', text: 'Игорь Есьман выбрал профессию архитектора и стал студентом Минского архитектурно-строительного техникума.'},
      {date: '1959', text: 'Окончил архитектурный факультет Белорусского политехнического института (ныне БНТУ).'},
      {date: '1960 - 1995', text: 'Работает в институте \'Минскпроект\', пройдя путь от простого архитектора до старшего, а затем главного архитектора проектов и руководителя мастерской.'},
      {date: '1995 - н.в.', text: 'Игорь Иванович находится в свободном творческом полете мысли, продолжая удивлять и радовать окружающих. Делает декорацию-трансформер для спектакля \'Ангел над крышей\'. Увлекается художественной резьбой по камню, кости, разрабатывает дизайн марок, выпускает миниатюрные книги, изучает и изготавливает предметы старины в миниатюрном варианте.'},
    ],
    project: [
      {date: '1958', text: 'Вход-тамбур в хлебный магазин по улице Романовская Слобода.'},
      {date: '1961 - 1963', text: 'Минский институт иностранных языков (ныне МГЛУ) по ул. Захарова.'},
      {date: '1964', text: 'Институт технической эстетики по ул. Жилуновича, производственный корпус, выставочный зал.'},
      {date: '1965', text: 'Экспериментальный детский сад-ясли на 320 мест в микрорайоне «Серебрянка-6» и повторно применяемые детские дошкольные учреждения.'},
      {date: '1966', text: 'Индивидуальные жилые дома по Партизанскому пр. и Романовской Слободе. Институт народного хозяйства, актовый и спортивный залы.'},
      {date: '1967', text: 'Первое место в открытом конкурсе на разработку эмблемы праздника, памятной медали и серии значков к 900-летию города Минска.'},
      {date: '1968', text: 'Комплекс административных зданий с залом заседаний по ул. Некрасова.'},
      {date: '1972', text: 'Комплекс общежитий с блоками обслуживания Института народного хозяйства по Велосипедному переулку.'},
      {date: '1970 - 1983', text: 'Архитектурно-строительный факультет БНТУ, проспект Независимости 150, г.Минск.'},
      {date: '1980', text: 'Комплекс зданий гостиницы «Орбита» по проспекту Пушкина.'},
      {date: '1990', text: 'Станция метро «Пушкинская».'},
    ],
    video: {
      id: 'jL_MPmr0U-U'
    },
    mapData: {
      center: [53.937772, 27.669495],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'http://www.minsk.nemiga.info/silicon-valley/bntu-8.jpg',
        width: 4,
        height: 3,
        title: 'Архитектурно-строительный факультет БНТУ',
        text: 'Архитектурно-строительный факультет БНТУ'
      },
      {
        num: 2,
        src: 'https://www.belarusinfo.by/ru/images/stories/photo_gallery/20k/15655/%D0%9C%D0%93%D0%9B%D0%A3.jpg',
        width: 4,
        height: 2,
        title: 'Минский государственный лингвистический университет',
        text: 'Минский государственный лингвистический университет'
      },
      {
        num: 3,
        src: 'http://bseu.by/images/hostels/5.jpg',
        width: 2,
        height: 2,
        title: 'Общежития Белорусского государственного экономического университета',
        text: 'Общежития Белорусского государственного экономического университета'
      },
      {
        num: 4,
        src: 'https://t-ec.bstatic.com/images/hotel/max1024x768/321/32147559.jpg',
        width: 4,
        height: 3,
        title: 'Гостиница Орбита, Минск',
        text: 'Гостиница Орбита, Минск'
      },
    ],
  },

  {
    id: 'A6',
    url: 'sacco',
    name: 'Джузеппе де Сакко',
    bornDate: '12/11/1900',
    born: '1735',
    deceased: '1798',
    description: 'Один из крупнейших архитекторов развитого барокко и классицизма, работавших на территории современной Беларуси, в XVIII веке. Придворный архитектор короля Станислава Августа Понятовского. Также работал в других регионах Речи Посполитой. В творчестве выделяются ансамбли дворцово-парковых резиденций.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG/375px-%D0%9F%D0%BE%D0%BC%D0%BD%D1%96%D0%BA_%D0%A1%D0%B0%D0%BA%D0%B0.JPG',
    placeOfResidence: 'Гродно',
    placeOfBirth: 'Верона',
    bio: [
      {date: '1768', text: 'Был приглашён в Варшаву, где занимался художественным катафалком (сastrum doloris) королевы Марии Лещинской и проектом перестройки костёла святого Яна.'},
      {date: '1771', text: 'Стал архитектором Скарбовой комиссии ВКЛ. Был рекомендован гродненскому старосте Антонию Тизенгаузу и принят на службу, в качестве королевского архитектора, с установленным окладом в 600 злотых. В Речи Посполитой Сакко получает ряд воинских званий ВКЛ.'},
      {date: '1771-1780', text: 'Выполнил ряд заказов местных магнатов, спроектировав несколько известных дворцово-парковых ансамблей и городских резиденций, в частности: Святский дворец магнатов Воловичей, Щорсовский дворец Хрептовичей, дворцы Тизенгауза в Поставах и Вильнюсе (предположительно).'}
    ],
    project: [
      {date: 'XVIII век', text: 'Дворец в Цёнжени'},
      {date: 'XVIII век', text: 'Дворец Хрептовичей в Щорсах'},
      {date: 'XVIII век', text: 'Театр Тизенгауза'},
      {date: 'XVIII век', text: 'Святский дворец'},
      {date: 'XVIII век', text: 'Дворец Тизенгауза'},
      {date: 'XVIII век', text: 'Мосарский дворец'},
    ],
    video: {
      id: 'TkaLjjNj8Ls'
    },
    mapData: {
      center: [53.684727, 23.834317],
      zoom: 12,
    },
    photos: [
      {
        num: 1,
        src: 'https://upload.wikimedia.org/wikipedia/commons/6/6c/Ci%C4%85%C5%BCe%C5%84_-_pa%C5%82ac_biskup%C3%B3w_pozna%C5%84skich_03.jpg',
        width: 4,
        height: 3,
        title: 'Дворец в Цёнжени',
        text: 'Дворец в Цёнжени'
      },
      {
        num: 2,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG/1920px-%D0%A1%D1%82%D0%B0%D0%BD%D0%B8%D1%81%D0%BB%D0%B0%D0%B2%D0%BE%D0%B2%D0%BE.JPG',
        width: 2,
        height: 2,
        title: 'Станиславово (усадьба)',
        text: 'Станиславово (усадьба)'
      },
      {
        num: 3,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG/1280px-%D0%90%D0%BD%D1%81%D0%B0%D0%BC%D0%B1%D0%BB%D1%8C_%D0%BF%D0%BB%D0%BE%D1%89%D0%B0%D0%B4%D0%B8_%D0%A2%D0%B8%D0%B7%D0%B5%D0%BD%D0%B3%D0%B0%D1%83%D0%B7%D0%B0.JPG',
        width: 2,
        height: 2,
        title: 'Ансамбль площади Тизенгауза',
        text: 'Ансамбль площади Тизенгауза'
      },
      {
        num: 4,
        src: 'https://upload.wikimedia.org/wikipedia/commons/9/97/%C5%9Aviacak._%D0%A1%D1%8C%D0%B2%D1%8F%D1%86%D0%B0%D0%BA_%282006%29.jpg',
        width: 4,
        height: 3,
        title: 'Святский дворец',
        text: 'Святский дворец'
      },
      {
        num: 5,
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG/1280px-%D0%A2%D0%B5%D0%B0%D1%82%D1%80_%D0%BA%D1%83%D0%BA%D0%BE%D0%BB_%D0%B2_%D0%93%D1%80%D0%BE%D0%B4%D0%BD%D0%BE.JPG',
        width: 4,
        height: 3,
        title: 'Театр Тизенгауза',
        text: 'Театр Тизенгауза'
      },
    ],
  },
];

const developers = [
  {
    id: 'D1',
    name: 'Иван Кононович',
    github: 'https://github.com/ivankononovich',
    image: 'https://avatars0.githubusercontent.com/u/41195901?s=400&v=4',
    contribution: '➤Создал базовую структуру проекта.\n ➤Реализовал переход между страницами с помощью react router.\n ➤Реализовал перевод сайта на три языка (текст писала вся команда).',
  },
  {
    id: 'D2',
    name: 'Евгений Матвеёнок',
    github: 'https://github.com/ins21',
    image: 'https://ins21.github.io/rsschool-2019Q1-cv/assets/images/1.png',
    contribution: '➤Создал компонент со страницей архитектора, используя Material UI.\n ➤Добавил компонент TimeLine и компонент Map.\n ➤Перевел страницы двух архитекторов на белорусский и английский.',
  },
  {
    id: 'D3',
    name: 'Катерина Жадько',
    github: 'https://github.com/cathzetjo',
    image: 'https://avatars3.githubusercontent.com/u/44948376?s=460&v=4',
    contribution: '\n' +
      ' ➤Компонент страницы разработчиков. Плюс структурирование и стилизация страницы с использованием Material UI.\n' +
      ' ➤Компонент галереи с фотографиями на страницах архитекторов.\n' +
      ' ➤Контент на странице архитектора Усовой Л.Д. с переводом.\n' +
      ' ➤Контент и изображение на главной странице.',
  },
  {
    id: 'D4',
    name: 'Артур Рубченко',
    github: 'https://github.com/Arthur199212',
    image: 'https://avatars0.githubusercontent.com/u/46008463?s=460&v=4',
    contribution: '➤Создал два компонента: меню сайта и архитектор дня.\n ➤Архитектор дня выбираеться по дате рождения, поэтому этот блок будет постоянно изменяться на того, у кого день рождения уже наступил и у кого эта дата ближайшая к текущей дате.\n ➤Меню сделано адаптивным и было реалиованно при помощи Material-UI.',
  },
  {
    id: 'D5',
    name: 'Дмитрий Пархоменко',
    github: 'https://github.com/DmitriyParhomenko',
    image: 'https://avatars0.githubusercontent.com/u/37816988?s=460&v=4',
    contribution: '➤Создал два компонента в которых используется Material UI: таблица проектов на странице архитектора и модальное окно показа видео с YouTube.\n ➤Оба компонента адаптивны. Для таблицы в адаптиве появляется горизонтальный скролл.\n ➤Провел работу по стилистики всего сайта.',
  },
  {
    id: 'D6',
    name: 'Павел Хомич',
    github: 'https://github.com/pashax0',
    image: 'https://avatars3.githubusercontent.com/u/17899361?s=460&v=4',
    contribution: '➤Создал компонент футер сайта с показом информации о разработчиках.\n ➤Реализация компонента поиска на станице архитекоров с выдачей результатов. Компоненты выполнены с использованием Material UI.\n ➤Базовая SEO оптимизация.',
  }
];

const portalDescription= {
  title: 'Архитекторы Беларуси',
  description: '<p>Архитектура страны — это своего рода имидж государства, она может раскрывать историческое наследие, говорить о вкусах, предпочтениях и уровне жизни государства.</p>' +
    '<p>Архитектура Беларуси является истинным свидетельством ее богатой истории. Памятники истории, архитектурные сооружения связаны со средневековым, восточно-европейским и русским искусством. Они впитали в себя национальные и европейские тенденции развития архитектуры. Замки Беларуси – это уникальные шедевры.</p>' +
    '<p>Многие постройки на территории страны выполнены в византийско-балканском стиле, что делает их более выраженными на фоне современных сооружений. Монументальные памятники в стиле барокко, дворцы в Гродно, Могилеве отличаются утонченностью и изысканностью. Дворцовые ансамбли в Гомеле относятся к памятникам классицизма.</p>' +
    '<p>Архитектура Беларуси связана с ее историческими событиями, переплетением художественных стилей. Многообразие стилей делает страну еще более яркой и живописной.</p>' +
    '<p>Беларусь имеет огромное историческое наследие. И сегодня создаются новые и реставрируются старинные шедевры архитектуры.</p>' +
    '<p>Этот портал о людях, сотворивших историю белорусской архитектуры своими руками.</p>',
  architectOfTheDay: 'Архитектор дня',
  img: 'https://i.ibb.co/Brsc9Sw/main-Picture.png',
};

const architectPageLanguage = {
  years: 'Годы жизни',
  bio: 'Биография',
  projects: 'Проекты',
  projectHeader: {
    columnOne: 'Проекты',
    columnTwo: 'Дата создания'
  },
  video: 'Видео',
  videoButton: 'Просмотр',
  map: 'Место основной деятельности',
  gallery: 'Фотогалерея',
};

export default {
  SEO: {
    lang: 'ru',
    title: 'Архитекторы Беларуси',
    description: 'Архитекторы Беларуси: биография и их работы. Кто построил здание, в каком году, чей проект'
  },
  architects,
  developers,
  portalDescription,
  architectPageLanguage,
  architectsNav: 'Архитекторы',
  developersList: 'Разработчики',
  homePageLink: 'Главная',
  searchLabel: 'Имя или место рождения',
  architectOfTheDayButton: 'Подробнее',
}
